import { render } from "./LightRegisterCard.vue?vue&type=template&id=777f8c5b&scoped=true"
import script from "./LightRegisterCard.vue?vue&type=script&lang=js"
export * from "./LightRegisterCard.vue?vue&type=script&lang=js"

import "./LightRegisterCard.vue?vue&type=style&index=0&id=777f8c5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777f8c5b"]])

export default __exports__